export default "__VITE_ASSET__DVf5c236__"